// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bobaSepolia as _bobaSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bobaSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 28882
 * Chain Name: Boba Sepolia
 * Default Block Explorer: https://testnet.bobascan.com
 * Default RPC URL: https://sepolia.boba.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bobaSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bobaSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bobaSepolia = createCommon({
	..._bobaSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
